import type { InviteResolution } from '../api/captureApi';

/**
 * When Google opens Maps instead of the review box, say what to tap there. Undefined keeps the
 * button's usual line (the review box opens directly).
 */
export function googleLinkHint(resolution: InviteResolution, copied: boolean): string | undefined {
  const paste = copied ? ', and paste your review' : '';
  if (resolution.googleLinkKind === 'maps_profile') {
    return `${copied ? 'We copy the review for you. ' : ''}Google Maps opens to ${resolution.practiceName}: tap Reviews, then Write a review${paste}.`;
  }
  if (resolution.googleLinkKind === 'maps_search') {
    return `${copied ? 'We copy the review for you. ' : ''}Google Maps opens a search: tap ${resolution.practiceName}, then Reviews, then Write a review${paste}.`;
  }
  return undefined;
}
